import vuetifyWidgets from '@it-enterprise/page-player-vuetify-widgets/src/vuetify-widgets/index'
import pagePlayerPlugin from '@it-enterprise/page-player'
import layouts from '@/app-model/layout'
import InitDataSources from '@/app-model/datasources/index'
let customWidgets = []

function InitPagePlayer(Vue, dataSources) {
  Vue.use(pagePlayerPlugin, {
    datasources: InitDataSources(dataSources),
    widgets: vuetifyWidgets.concat(customWidgets),
    layouts: layouts
  })
} 

export default InitPagePlayer

